module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block2"
  }, [_c('div', {
    staticClass: "sectionWrap",
    on: {
      "click": _vm.autofocus
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.reason),
      expression: "reason",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "section",
    attrs: {
      "cols": "5",
      "autofocus": "autofocus",
      "wrap": "hard",
      "placeholder": "请输入您不同意的原因"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "blur": [_vm.resetWindow, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('span', {
    staticClass: "tag research-font-color"
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col2 research-background-color",
    on: {
      "click": function($event) {
        _vm.$emit('toggleShow') && _vm.$emit('confirm', _vm.reason)
      }
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("您不同意的原因是？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea11c9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupComponents/ResearchGroupDisagreeBox.vue
// module id = 1669
// module chunks = 8